/** @jsxImportSource @emotion/react */
import { IconCheck, IconX } from 'featherico';
import * as React from 'react';
import ReactToggle from 'react-toggle';
import colours from '../../../colours';
import styles from './style.m.less';

interface Props {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    label?: React.ReactNode;
    subLabel?: React.ReactNode;
    id?: string;
}

export default function Toggle({
    checked,
    onChange,
    disabled = false,
    label = undefined,
    subLabel = undefined,
    id,
}: Props) {
    return (
        <React.Fragment>
            <label
                css={{
                    display: 'flex',
                    alignItems: 'center',
                    width: 'fit-content',
                    height: 'fit-content',
                }}
            >
                <ReactToggle
                    className={styles.reactToggle}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    icons={{
                        checked: <IconCheck css={{ marginTop: '0 !important' }} />,
                        unchecked: <IconX css={{ marginTop: '0 !important' }} />,
                    }}
                    id={id}
                />

                {label && <div css={{ marginLeft: 5, color: disabled ? colours.SIGray2 : 'inherit' }}>{label}</div>}
            </label>
            {subLabel && <div className={styles.subLabel}>{subLabel}</div>}
        </React.Fragment>
    );
}
